// extracted by mini-css-extract-plugin
export var logo = "_m1-2";
export var logoWrapper = "_m1-1";
export var strip = "_m1-0";